export function getVariantProps(props) {
    var _a;
    if (props.depressed)
        props.variant = 'depressed';
    if (props.flat)
        props.variant = 'flat';
    if (props.link)
        props.variant = 'link';
    if (props.menu)
        props.variant = 'menu';
    if (props.outlined)
        props.variant = 'outlined';
    if (props.text)
        props.variant = 'text';
    var classes = (_a = {
            '__button': true,
            'hover': props.hover,
            'disabled': props.disabled,
            'loading': props.loading
        },
        _a["button-variant-".concat(props.variant || 'depressed')] = true,
        _a);
    return {
        classes: classes,
        props: { disabled: props.disabled },
        styles: {},
        variables: {}
    };
}
